import React from 'react';
import XLSX from 'sheetjs-style';
import FileSaver from 'file-saver';
import { Button, Tooltip } from 'antd';
import { FileExcelOutlined } from '@ant-design/icons';
import { dateNow } from './utility';

interface Props {
    excelData: any[];
    fileName: string;
    columnMappings?: { [key: string]: string };
}

const ExportExcel: React.FC<Props> = ({ excelData, fileName, columnMappings }) => {
    const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const fileExtension = '.xlsx';
    const exportDataToExcel = () => {
        if (!excelData || excelData.length === 0) return;

        const modifiedData = excelData.map(row => {
            const modifiedRow: { [key: string]: any } = {};

            Object.keys(columnMappings || {}).forEach(originalKey => {
                if (row.hasOwnProperty(originalKey)) {
                    modifiedRow[columnMappings![originalKey]] = row[originalKey];
                }
            });

            return modifiedRow;
        });

        if (modifiedData.length === 0) return;

        const ws = XLSX.utils.json_to_sheet(modifiedData);
        ws['!cols'] = Object.keys(modifiedData[0]).map(column => ({ wch: 25 }));

        const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const data = new Blob([excelBuffer], { type: fileType });

        FileSaver.saveAs(data, dateNow(fileName) + fileExtension);
    };

    return (
        <Tooltip
            title="Excele Aktar"
            color="#1677ff">
            <Button
                type="primary"
                title='Dışa Aktar'
                icon={<FileExcelOutlined />}
                onClick={exportDataToExcel}
                className='mr-2'>
                Dışa Aktar
            </Button>
        </Tooltip>
    );
}

export default ExportExcel;
